<template>
  <div>
    <v-card elevation="0">
      <v-container fluid>
        <v-row>
          <v-col cols="4" md="6" lg="4" sm="12" v-for="service in list" :key="service.id">
            <service-card :service="service"></service-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ServiceCard from "../../components/services/Card";

export default {
  components: {
    ServiceCard
  },

  computed: {
    ...mapState("services", {
      list: state => state.list
    })
  },
  mounted() {
    this.initialite();
  },
  methods: {
    initialite() {
      this.getServices();
    },
    getServices() {
      this.$store.dispatch("services/list");
    }
  }
};
</script>

<style>
</style>